import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <Result
        status="404"
        title="404"
        subTitle="La página que buscas no existe o fue movida."
        extra={
          <div className="flex gap-3 justify-center">
            <Button type="primary" onClick={() => navigate('/')}>
              Volver al inicio
            </Button>
            <Button onClick={() => navigate(-1)}>
              Volver atrás
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default NotFound;
